const HOUR = '([0-1]\\d|[2][0-3])';
const MINUTE = '([0-5]\\d)';
const SECOND = MINUTE;

const DATE = '(\\d{4})-([0]\\d|[1][0-2])-([0-2]\\d|[3][0-1])';
const TIME = `${HOUR}:${MINUTE}(:${SECOND})?(\\.(\\d+))?([+-]${HOUR}:${MINUTE}|[Z])?`;

export const DEFAULT = 'default';
export const SHORT = 'short';
export const NUMERIC = 'numeric';

export const VALID_DATE_FORMATS = {
  DEFAULT,
  SHORT,
  NUMERIC,
};

export const ISO_DATE = new RegExp(`^${DATE}[Z]?$`);
export const ISO_DATETIME = new RegExp(`^${DATE}T${TIME}$`);
export const TIME_TOKENS = new Set(['Z', '+', '-']);

type Formats = typeof VALID_DATE_FORMATS;

export type Format = Formats[keyof Formats];

export interface Options {
  format?: Format; // can either be 'numeric', 'short' or 'default'
  locale?: string;
  utc?: boolean;
  weekday?: boolean;
  year?: boolean;
}

export interface RelativeOptions {
  format?: Format; // can either be 'numeric', 'short' or 'default'
  locale?: string;
}

export const VALID_FORMATS = new Set<string | undefined>(
  Object.values(VALID_DATE_FORMATS)
).add(undefined);
